import Spinner from '@atlaskit/spinner';
import { Environment, Storage, Url } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { SocialSignupOptionsType } from '../../../../../model/wac-signup-layout';
import { SocialSignUpView } from '../../social-sign-up';

/**
 * Social signin component that renders
 * when a user is returning from a social signup
 *
 * Will render social-signin if  showSocialSignupForm is
 * enabled, and if the user is logged in. Otherwise, will render
 * children components
 */

export const SocialSignup: React.FC<SocialSignupOptionsType> = ({
  locale,
  userInfo,
  productKeys,
  analyticsTrack,
  loadingImageSrc,
  errorImageSrc,
  showSocialSignupForm,
  children,
  siteRenamePageUrl,
  templateId
}) => {
  const [renderSocialSignup, setRenderSocialSignup] = useState(
    !!(showSocialSignupForm && userInfo?.isLoggedIn)
  );

  useEffect(() => {
    setRenderSocialSignup(!!(showSocialSignupForm && userInfo?.isLoggedIn));
  }, [userInfo]);

  const queryParameters = Url.getUrlParams() || {};

  // If this is the signup form and there is session stored userInfo, we remove it
  const socialSignupInfo = JSON.parse(
    window.atob(Storage.getSessionStorage('social-signup') || '') || '{}'
  );
  if (
    socialSignupInfo &&
    !showSocialSignupForm &&
    !_.isEqual(userInfo, socialSignupInfo?.userInfo)
  ) {
    Storage.removeSessionStorage('social-signup');
  }

  if (!userInfo && showSocialSignupForm) {
    // knowing that showSocialSignupForm is enabled,
    // defer showing anything until logged in state is available
    return (
      <SpinnerWrapper>
        <Spinner size="large" />
      </SpinnerWrapper>
    );
  }

  return renderSocialSignup ? (
    <SocialSignUpView
      loadingImageUrl={loadingImageSrc}
      productKeys={productKeys}
      userInfo={userInfo}
      locale={_.get(locale, 'locale')}
      isStaging={!Environment.isProduction()}
      wacEnvUrl={Environment.getWacIntegrationUrl()}
      devMode={queryParameters.hasOwnProperty('developer')}
      analyticsTrack={analyticsTrack}
      setShowSignupForm={(val: boolean) => {
        // tslint:disable-next-line:no-console
        console.log(val);
      }}
      setShowSocialSignupForm={setRenderSocialSignup}
      tryAgainErrorUrl={Environment.getIdentityBaseUrl()}
      errorImageSrc={errorImageSrc}
      siteRenamePageUrl={siteRenamePageUrl}
      templateId={templateId}
    />
  ) : (
    <>{children}</>
  );
};

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
